module.exports = __webpack_public_path__ + "img/5.2647ad80.jpg";